export const optionFieldType = {
  string: 0,
};
export const configOptionType = {
  helpPageLink: 1,
};
